import { ICellRendererParams } from 'ag-grid-community';

import { IPartFinderAttribute } from 'companySettings/types';
import { Link } from 'core/elements';
import { Level } from 'theme/enums';

import { UpsertPartFinderAttributeButton } from '../UpsertPartFinderAttribute';

// The name opens the list in its edit drawer.
export const NameCell = ({ data }: ICellRendererParams<IPartFinderAttribute>) => {
  if (!data) {
    return null;
  }

  return (
    <UpsertPartFinderAttributeButton
      attribute={data}
      buttonElement={
        <Link component="button" level={Level.TITLE_SM} sx={{ fontWeight: 'bold' }}>
          {data.name}
        </Link>
      }
    />
  );
};
